export function getMedalStyle(rank: number): string {
    if (rank === 1) return 'bg-amber-400 text-white';
    if (rank === 2) return 'bg-slate-300 text-white';
    if (rank === 3) return 'bg-amber-600 text-white';
    return 'bg-slate-100 text-slate-500';
}
